import { EmptyState } from "components/common/modals/modal.styles";
import { SectionHeader, SectionTitle } from "components/common/Section/index.styles";
import styled from "styled-components";


export const PostsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
  width: calc(100% - 3rem);
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    width: calc(100% - 2rem);
    margin: 1rem;
    padding: 1rem;
  }
`;

export const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr) auto;
  gap: 0.75rem;
  width: 100%;
  aspect-ratio: 4/3;

  > div:nth-child(1) {
    grid-column: 1 / span 2;
    grid-row: 1;
  }

  > div:nth-child(2) {
    grid-column: 3 / span 2;
    grid-row: 1 / span 2;
  }

  > div:nth-child(3) {
    grid-column: 1 / span 2;
    grid-row: 2 / span 2;
  }

  > div:nth-child(4) {
    grid-column: 3 / span 2;
    grid-row: 3;
  }

  > div:nth-child(5) {
    grid-column: 1 / span 4;
    grid-row: 4;
  }
`;

export const PostsSectionHeader = SectionHeader

export const PostsSectionTitle = SectionTitle

export const PostsEmptyState = EmptyState
